module.exports = __webpack_public_path__ + "static/media/wafflesDesktop.8f30c2e3.svg";